import React, {useState} from 'react';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import {useIntl} from 'react-intl';

import PromotedTable from '../../components/relevance/PromotedTable';
import DemandChart from '../../components/relevance/DemandChart';
import DistributionCharts from '../../components/relevance/DistributionCharts';
import EventFactsPanel from '../../components/relevance/EventFactsPanel';

function RelevancePage() {
    const intl = useIntl();
    const [activeKey, setActiveKey] = useState('promoted');
    const [visited, setVisited] = useState({
        promoted: true,
        demand: false,
        distribution: false,
    });
    const [selectedEventId, setSelectedEventId] = useState(null);

    function handleSelect(key) {
        setActiveKey(key);
        setVisited((previous) =>
            previous[key] ? previous : {...previous, [key]: true},
        );
    }

    return (
        <div data-test='relevancePageComponent'>
            <Tabs
                id='relevance-tabs'
                activeKey={activeKey}
                onSelect={handleSelect}
            >
                <Tab
                    eventKey='promoted'
                    title={intl.formatMessage({
                        id: 'RELEVANCE.TAB_PROMOTED',
                    })}
                >
                    {visited.promoted && (
                        <PromotedTable onSelectEvent={setSelectedEventId} />
                    )}
                </Tab>
                <Tab
                    eventKey='demand'
                    title={intl.formatMessage({id: 'RELEVANCE.TAB_DEMAND'})}
                >
                    {visited.demand && <DemandChart />}
                </Tab>
                <Tab
                    eventKey='distribution'
                    title={intl.formatMessage({
                        id: 'RELEVANCE.TAB_DISTRIBUTION',
                    })}
                >
                    {visited.distribution && <DistributionCharts />}
                </Tab>
            </Tabs>
            <EventFactsPanel
                eventId={selectedEventId}
                show={selectedEventId !== null}
                onHide={() => setSelectedEventId(null)}
            />
        </div>
    );
}

export default RelevancePage;
